import React, { useContext } from 'react';

export const SiteContext = React.createContext<Partial<Site.Site>>({});

export interface SiteContextProviderProps {
	site: Site.Site;
	children?: React.ReactNode;
}
export const SiteContextProvider = ({ site, children }: SiteContextProviderProps) => {
	return <SiteContext.Provider value={site}>{children}</SiteContext.Provider>;
};

export function useSiteContext(): Partial<Site.Site> {
	return useContext(SiteContext);
}
